import { api_configuration } from "../../common";
import { IdPathBuilder } from "../navigation/IdPathBuilder";
import api_views = api_configuration.libraries.gui_definition_lib.types.views.alan_api;
import api_settings = api_configuration.libraries.gui_definition_lib.types.settings.alan_api;
import api_cs = api_configuration.types.client_state.alan_api;
import { registerIdPath, registerNodeContext } from "../state/registerClientState";
import Window = require("../widgets/dom/Window");
import DestructorTree from "../DestructorTree";

export default function (
	context: IdPathBuilder | api_cs.Cnode,
	view: api_views.Cviews__,
	window: api_settings.Cwindows,
	in_front = true
): api_cs.Copen_views {
	const window_instance = Window.getWindowInstance(window.key);
	let open_view = window_instance.is_view_open(context, view);
	if (open_view === "no") {
		const destructor = new DestructorTree();
		let node: api_cs.Cnode;
		if (context instanceof IdPathBuilder) {
			node = registerIdPath(context, destructor);
		} else {
			node = context;
			registerNodeContext(node, destructor);
		}
		open_view = window_instance.open_view(node, view, undefined, in_front);
		open_view.onDestroy(() => destructor.destroy());
	} else {
		window_instance.activate_view(open_view, in_front);
	}
	return open_view;
}
